import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  BANCOS_INTEGRACAO,
  BancoIntegracaoEnum,
  CnabPadraoEnum,
  DescricaoTipoConta,
  infoBanco,
  TipoContaCorrenteEnum,
} from 'src/app/enum/banco-integracao.enum';
import { ContaCorrenteService } from 'src/app/service/contaCorrente.service';
import { ContaCorrente } from './contacorrente';

@Component({
  selector: 'app-conta-corrente-form',
  templateUrl: './conta-corrente-form.component.html',
  styleUrls: ['./conta-corrente-shared.scss'],
})
export class ContaCorrenteFormComponent implements OnInit {

  formulario: FormGroup;
  editando = false;
  carregando = false;
  possuiClientSecret = false;
  possuiCertificado = false;
  nomeCertificado = '';
  certificadoArquivo: File | null = null;

  bancos = BANCOS_INTEGRACAO;
  tiposConta = Object.values(TipoContaCorrenteEnum);
  padroesCnab = Object.values(CnabPadraoEnum);
  descricaoTipoConta = DescricaoTipoConta;

  constructor(
    private fb: FormBuilder,
    private service: ContaCorrenteService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  ngOnInit(): void {
    this.montarForm();
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.carregarConta(+id);
    }
  }

  montarForm(conta?: ContaCorrente) {
    this.formulario = this.fb.group({
      id: [conta?.id ?? null],
      descricao: [conta?.descricao ?? '', Validators.required],
      ativa: [conta?.ativa ?? true],
      dataAbertura: [this.formatarDataInput(conta?.dataAbertura)],
      tipoConta: [conta?.tipoConta ?? TipoContaCorrenteEnum.CORRENTE, Validators.required],
      banco: [conta?.banco ?? null, Validators.required],
      codigoBanco: [conta?.codigoBanco ?? ''],
      agencia: [conta?.agencia ?? ''],
      cnab: [conta?.cnab ?? CnabPadraoEnum.CNAB240],
      numeroConta: [conta?.numeroConta ?? ''],
      digitoConta: [conta?.digitoConta ?? ''],
      carteira: [conta?.carteira ?? ''],
      variacaoCarteira: [conta?.variacaoCarteira ?? ''],
      convenio: [conta?.convenio ?? ''],
      codigoTransmissaoRemessa: [conta?.codigoTransmissaoRemessa ?? ''],
      codigoCedente: [conta?.codigoCedente ?? ''],
      digitoCedente: [conta?.digitoCedente ?? ''],
      numeroContrato: [conta?.numeroContrato ?? ''],
      numeroContaCorrente: [conta?.numeroContaCorrente ?? null],
      clientId: [conta?.clientId ?? ''],
      chavePix: [conta?.chavePix ?? ''],
      nomeRecebedorPix: [conta?.nomeRecebedorPix ?? ''],
      multaTipo: [conta?.multaTipo ?? null],
      multaValor: [conta?.multaValor ?? null],
      jurosTipo: [conta?.jurosTipo ?? null],
      jurosValor: [conta?.jurosValor ?? null],
      clientSecret: [''],
      senhaCertificado: [''],
      numeroRemessaRetorno: [conta?.numeroRemessaRetorno ?? null],
      numeroRemessaRetornoContaPagar: [conta?.numeroRemessaRetornoContaPagar ?? null],
      qtdDiasBaixarBoletoRegistrado: [conta?.qtdDiasBaixarBoletoRegistrado ?? 120],
      qtdDiasMaxFiltrarRemessa: [conta?.qtdDiasMaxFiltrarRemessa ?? 30],
      qtdDiasConsiderarBoletoAVencer: [conta?.qtdDiasConsiderarBoletoAVencer ?? 0],
      especieTituloBoleto: [conta?.especieTituloBoleto ?? ''],
      carteiraRegistrada: [conta?.carteiraRegistrada ?? false],
      permitirEmissaoBoletoVencido: [conta?.permitirEmissaoBoletoVencido ?? true],
      permiteEnviarBoletoVencidoRemessa: [conta?.permiteEnviarBoletoVencidoRemessa ?? false],
      emissaoBoletoPeloBanco: [conta?.emissaoBoletoPeloBanco ?? false],
      utilizaAbatimentoTaxasRepasse: [conta?.utilizaAbatimentoTaxasRepasse ?? false],
      gerarRemessaSemDescontoAbatido: [conta?.gerarRemessaSemDescontoAbatido ?? true],
      habilitarRegistroRemessaOnline: [conta?.habilitarRegistroRemessaOnline ?? false],
      enviarRemessaApenasBoletoImpresso: [conta?.enviarRemessaApenasBoletoImpresso ?? false],
      gerarContaPagarTaxasBancarias: [conta?.gerarContaPagarTaxasBancarias ?? true],
      formaPagamentoPadraoTaxas: [conta?.formaPagamentoPadraoTaxas ?? ''],
      categoriaDespesaPadraoTaxas: [conta?.categoriaDespesaPadraoTaxas ?? ''],
    });
    this.editando = !!conta?.id;
  }

  carregarConta(id: number) {
    this.carregando = true;
    this.service.buscar(id).subscribe(c => {
      this.editando = true;
      this.formulario.patchValue({
        id: c.id,
        descricao: c.descricao ?? '',
        ativa: c.ativa ?? true,
        dataAbertura: this.formatarDataInput(c.dataAbertura),
        tipoConta: c.tipoConta ?? TipoContaCorrenteEnum.CORRENTE,
        banco: c.banco ?? null,
        codigoBanco: c.codigoBanco ?? '',
        agencia: c.agencia ?? '',
        cnab: c.cnab ?? CnabPadraoEnum.CNAB240,
        numeroConta: c.numeroConta ?? '',
        digitoConta: c.digitoConta ?? '',
        carteira: c.carteira ?? '',
        variacaoCarteira: c.variacaoCarteira ?? '',
        convenio: c.convenio ?? '',
        codigoTransmissaoRemessa: c.codigoTransmissaoRemessa ?? '',
        codigoCedente: c.codigoCedente ?? '',
        digitoCedente: c.digitoCedente ?? '',
        numeroContrato: c.numeroContrato ?? '',
        numeroContaCorrente: c.numeroContaCorrente ?? null,
        clientId: c.clientId ?? '',
        chavePix: c.chavePix ?? '',
        nomeRecebedorPix: c.nomeRecebedorPix ?? '',
        multaTipo: c.multaTipo ?? null,
        multaValor: c.multaValor ?? null,
        jurosTipo: c.jurosTipo ?? null,
        jurosValor: c.jurosValor ?? null,
        clientSecret: '',
        senhaCertificado: '',
        numeroRemessaRetorno: c.numeroRemessaRetorno ?? null,
        numeroRemessaRetornoContaPagar: c.numeroRemessaRetornoContaPagar ?? null,
        qtdDiasBaixarBoletoRegistrado: c.qtdDiasBaixarBoletoRegistrado ?? 120,
        qtdDiasMaxFiltrarRemessa: c.qtdDiasMaxFiltrarRemessa ?? 30,
        qtdDiasConsiderarBoletoAVencer: c.qtdDiasConsiderarBoletoAVencer ?? 0,
        especieTituloBoleto: c.especieTituloBoleto ?? '',
        carteiraRegistrada: c.carteiraRegistrada ?? false,
        permitirEmissaoBoletoVencido: c.permitirEmissaoBoletoVencido ?? true,
        permiteEnviarBoletoVencidoRemessa: c.permiteEnviarBoletoVencidoRemessa ?? false,
        emissaoBoletoPeloBanco: c.emissaoBoletoPeloBanco ?? false,
        utilizaAbatimentoTaxasRepasse: c.utilizaAbatimentoTaxasRepasse ?? false,
        gerarRemessaSemDescontoAbatido: c.gerarRemessaSemDescontoAbatido ?? true,
        habilitarRegistroRemessaOnline: c.habilitarRegistroRemessaOnline ?? false,
        enviarRemessaApenasBoletoImpresso: c.enviarRemessaApenasBoletoImpresso ?? false,
        gerarContaPagarTaxasBancarias: c.gerarContaPagarTaxasBancarias ?? true,
        formaPagamentoPadraoTaxas: c.formaPagamentoPadraoTaxas ?? '',
        categoriaDespesaPadraoTaxas: c.categoriaDespesaPadraoTaxas ?? '',
      });
      if (c.banco) {
        this.onBancoChange(c.banco as BancoIntegracaoEnum);
      }
      this.possuiClientSecret = !!c.possuiClientSecret;
      this.possuiCertificado = !!c.possuiCertificado;
      this.nomeCertificado = c.nomeCertificado ?? '';
      this.certificadoArquivo = null;
      this.carregando = false;
    }, err => {
      this.carregando = false;
      this.snackBar.open(this.mensagemErro(err, 'Erro ao carregar conta.'), 'ERRO', { duration: 4000 });
      this.voltarConsulta();
    });
  }

  formatarDataInput(data: unknown): string | null {
    if (data == null || data === '') return null;
    if (Array.isArray(data) && data.length >= 3) {
      const [ano, mes, dia] = data;
      return `${ano}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
    }
    if (typeof data === 'string') {
      if (/^\d{4}-\d{2}-\d{2}/.test(data)) return data.substring(0, 10);
      if (data.includes('/')) {
        const p = data.split('/');
        if (p.length === 3) return `${p[2]}-${p[1].padStart(2, '0')}-${p[0].padStart(2, '0')}`;
      }
    }
    return null;
  }

  bancoSelecionadoSuportaApi(): boolean {
    return !!infoBanco(this.formulario?.value?.banco)?.suportaApi;
  }

  bancoExigeClientSecret(): boolean {
    const info = infoBanco(this.formulario?.value?.banco);
    return info?.exigeClientSecret !== false;
  }

  onBancoChange(codigo: BancoIntegracaoEnum) {
    const info = infoBanco(codigo);
    if (info) {
      this.formulario.patchValue({ codigoBanco: info.codigoFebraban });
    }
  }

  onCertificadoSelecionado(event: Event) {
    const input = event.target as HTMLInputElement;
    this.certificadoArquivo = input.files?.length ? input.files[0] : null;
  }

  prepararPayload(): ContaCorrente {
    const bruto = this.formulario.getRawValue();
    const payload: ContaCorrente = { ...bruto };
    payload.id = bruto.id ? Number(bruto.id) : undefined;
    payload.dataAbertura = bruto.dataAbertura || null;
    payload.numeroContaCorrente = bruto.numeroContaCorrente === '' || bruto.numeroContaCorrente == null
      ? undefined : Number(bruto.numeroContaCorrente);
    if (!payload.clientSecret || String(payload.clientSecret).startsWith('****')) {
      delete payload.clientSecret;
    }
    if (this.possuiClientSecret && !payload.clientSecret) {
      payload.possuiClientSecret = true;
    }
    if (!payload.senhaCertificado) {
      delete payload.senhaCertificado;
    }
    return payload;
  }

  private validarCertificadoAntesSalvar(): string | null {
    if (!this.bancoSelecionadoSuportaApi()) {
      return null;
    }
    if (this.certificadoArquivo && !this.formulario.value.senhaCertificado) {
      return 'Informe a senha do certificado digital.';
    }
    if (!this.possuiCertificado && !this.certificadoArquivo) {
      return 'Anexe o certificado digital (.pfx) da conta corrente Sicoob.';
    }
    return null;
  }

  private enviarCertificado(contaId: number, callback: (res: ContaCorrente) => void, onError: (err: HttpErrorResponse) => void) {
    if (!this.certificadoArquivo) {
      callback({ id: contaId } as ContaCorrente);
      return;
    }
    this.service.anexarCertificado(contaId, this.certificadoArquivo, this.formulario.value.senhaCertificado)
      .subscribe(callback, onError);
  }

  private mensagemErro(err: unknown, padrao: string): string {
    if (err instanceof HttpErrorResponse) {
      const body = err.error;
      if (body && typeof body === 'object' && 'message' in body && typeof body.message === 'string') {
        return body.message;
      }
      return err.message || padrao;
    }
    return padrao;
  }

  submit() {
    if (this.formulario.invalid) {
      this.snackBar.open('Preencha os campos obrigatórios (banco e nome).', 'ERRO', { duration: 2000 });
      return;
    }
    const erroCert = this.validarCertificadoAntesSalvar();
    if (erroCert) {
      this.snackBar.open(erroCert, 'ERRO', { duration: 4000 });
      return;
    }
    this.service.salvar(this.prepararPayload()).subscribe(res => {
      const finalizar = (conta: ContaCorrente) => {
        this.snackBar.open(this.editando ? 'Conta atualizada!' : 'Conta salva!', 'OK', { duration: 2000 });
        this.editando = true;
        this.possuiClientSecret = !!conta.possuiClientSecret || !!this.formulario.value.clientSecret;
        this.possuiCertificado = !!conta.possuiCertificado;
        this.nomeCertificado = conta.nomeCertificado ?? this.nomeCertificado;
        this.certificadoArquivo = null;
        this.formulario.patchValue({ id: conta.id ?? res.id, clientSecret: '', senhaCertificado: '' });
        if (!this.route.snapshot.paramMap.get('id') && (conta.id ?? res.id)) {
          this.router.navigate(['/contaCorrente/form', conta.id ?? res.id], { replaceUrl: true });
        }
      };
      if (this.certificadoArquivo && res.id) {
        this.enviarCertificado(res.id, finalizar, err => {
          this.snackBar.open(
            this.mensagemErro(err, 'Conta salva, mas falhou ao anexar certificado.'),
            'ERRO',
            { duration: 5000 },
          );
          finalizar(res);
        });
      } else {
        finalizar(res);
      }
    }, err => {
      this.snackBar.open(this.mensagemErro(err, 'Erro ao salvar.'), 'ERRO', { duration: 5000 });
    });
  }

  limpar() {
    this.router.navigate(['/contaCorrente/form']);
    this.montarForm();
    this.editando = false;
    this.possuiCertificado = false;
    this.nomeCertificado = '';
    this.certificadoArquivo = null;
  }

  voltarConsulta() {
    this.router.navigate(['/contaCorrente/consulta']);
  }
}
